import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import type { ChangeCheckRes } from '@/types/api/message/change-check';

/**
 * 轮询间隔 atom（持久化到 localStorage）
 * Polling interval atom (persisted to localStorage)
 * atomWithStorage 自动处理读写错误
 * atomWithStorage automatically handles read/write errors
 */
export const pollingIntervalAtom = atomWithStorage('polling-interval', 5000);

/**
 * change-check 接口返回结果
 * change-check API response result
 *
 * 每次轮询返回新数据时，对象引用会改变，触发所有订阅者重新检查
 * When polling returns new data, the object reference changes, triggering all subscribers to re-check
 */
export const changeCheckResultAtom = atom<ChangeCheckRes | null>(null);

/**
 * 降级状态 atom（连续失败时延长间隔）
 * Degraded status atom (extend interval when consecutive failures occur)
 */
export const pollingDegradedAtom = atom(false);

/**
 * 强制快速轮询截止时间 atom
 * Force quick polling expiration timestamp atom
 *
 * 用于充值/提现后强制 5 秒轮询，优先级高于游戏场景
 * Used to force 5s polling after deposit/withdrawal, higher priority than game scenario
 *
 * 值为 0 或小于当前时间表示未激活
 * Value of 0 or less than current time means inactive
 */
export const forceQuickPollingUntilAtom = atom(0);
